import StyledLink from '../StyledLink'
import { SPACES } from '../routes'
import type { Props } from '../types'

const LinkToSpaceHub = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SPACES}
  >
    {children}
  </StyledLink>

export default LinkToSpaceHub
